import styled, { keyframes } from 'styled-components'

import { TSpinnerContainerProps } from '../types'

const SpinnerContainer = styled.div<TSpinnerContainerProps>`
  min-height: ${({ $pxToSubtractFrom100vh }) =>
    $pxToSubtractFrom100vh ? `calc(100vh - ${$pxToSubtractFrom100vh}px)` : '100vh'};
  min-width: calc(100vw - 48px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
`

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const Svg = styled.svg`
  animation: ${rotate} 2s linear infinite;
`

const Circle = styled.circle`
  opacity: 0.35;
`

export { SpinnerContainer, Svg, Circle }
